import { render, staticRenderFns } from "./ContentFolderSetting.vue?vue&type=template&id=35ffaae2&scoped=true"
import script from "./ContentFolderSetting.vue?vue&type=script&lang=js"
export * from "./ContentFolderSetting.vue?vue&type=script&lang=js"
import style0 from "./ContentFolderSetting.vue?vue&type=style&index=0&id=35ffaae2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ffaae2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ffaae2')) {
      api.createRecord('35ffaae2', component.options)
    } else {
      api.reload('35ffaae2', component.options)
    }
    module.hot.accept("./ContentFolderSetting.vue?vue&type=template&id=35ffaae2&scoped=true", function () {
      api.rerender('35ffaae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/ContentFolderSetting.vue"
export default component.exports